// Non usare i trattini perchè causano errori
export const PRICELISTS_DESCRIBE: string = 'pricelists';